import Link from 'next/link';
import React from 'react';
import { Box } from '@chakra-ui/react';
import { NavigationDetails } from './interfaces';
import { ProjectConfigQuery } from '@src/generated/graphql';
import NavigationItem from '@src/theme/chakraTheme/components/NavigationItem';
import { DeepExtractTypeSkipArrays } from '@src/types/extract-types';

type NavigationItem = DeepExtractTypeSkipArrays<
  ProjectConfigQuery,
  ['allMyProjectsConfig', 'navigation']
>;

interface NavigationItemProps {
  navigation: NavigationDetails;
  isSelected: boolean;
}

const InnerNavigationItem: React.FC<NavigationItemProps> = ({
  isSelected,
  navigation,
}) => {
  const { slug, title } = navigation;
  return (
    <Box flex="0 1 151px" height="100%">
      <Link key={title} href={slug?.current ?? ''}>
        <NavigationItem variant={isSelected ? 'selected' : 'normal'}>
          {title}
        </NavigationItem>
      </Link>
    </Box>
  );
};

export default InnerNavigationItem;
